import { UserProfile as PlainUserProfile } from '../../services/generated/app-api/models';
import UserTheme from './UserTheme';

export default class UserProfile implements PlainUserProfile {
    firstName = '';
    lastName = '';
    nickname = '';
    picture = '';
    userId = '';
    email = '';
    emailVerified = false;
    theme = new UserTheme();
    created = new Date();
    lastSignIn = new Date();
    lastPasswordChange = new Date();

    constructor(props?: Partial<UserProfile>) {
        Object.assign(this, props);
    }

    get name(): string {
        if (this.firstName && this.lastName) {
            return `${this.firstName} ${this.lastName}`.trim();
        } else if (this.firstName) {
            return this.firstName.trim();
        } else if (this.lastName) {
            return this.lastName.trim();
        }
        return '';
    }

    get displayName(): string {
        return this.nickname || this.name;
    }

    get initials(): string {
        const firstName = this.firstName;
        const lastName = this.lastName;
        const username = this.nickname;
        const displayName = this.displayName;

        if (firstName && lastName) {
            return firstName.charAt(0) + lastName.charAt(0);
        }

        if (firstName) {
            return firstName.charAt(0);
        }

        if (username) {
            return username.charAt(0);
        }

        if (lastName) {
            return lastName.charAt(0);
        }

        if (displayName) {
            return displayName.charAt(0);
        }

        return '';
    }
}
